import { render } from "./FactoryLogs.vue?vue&type=template&id=7bf160d1"
import script from "./FactoryLogs.vue?vue&type=script&lang=js"
export * from "./FactoryLogs.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__